import { useState } from "react";
import "./UserProfile.css";
import { Icon } from "@iconify/react";
import { useAuth } from "../../Context/UserContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { url } from "../../constants/url";
import { toast } from "react-toastify";
import {
  faCaretRight,
  faEnvelopeCircleCheck,
  faXmark,
  faEye,
  faEyeSlash,
} from "@fortawesome/free-solid-svg-icons";
import { useRef } from "react";
import GuidedTour from '../Pages/GuidedTour'

const UserProfile = ({ setOpenUserProfile, firstLetter, toggleDropdown }) => {
  const {
    user,
    emailVer,
    logout,
    userRole,
    multifactor,
    mfaTour,
    checkAuth,
  } = useAuth();
  
  const [openUpdatePassword, setOpenUpdatePassword] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [passwordView, setPasswordView] = useState(false);
  const [confirmPasswordView, setConfirmPasswordView] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [oldPasswordError, setOldPasswordError] = useState("");
  const [newPasswordError, setNewPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [loading, setLoading] = useState(false);
  const [openIdentity, setOpenIdentity] = useState(false)
  const [otpSent, setOTPSent] = useState(false)
  const [otp, setOtp] = useState(["", "", "", "", "", ""])
  const [otpError, setOtpError] = useState(false)
  const [timer, setTimer] = useState(60);
  const [canResend, setCanResend] = useState(false);
  const [showResend, setShowResend] = useState(true);
  const [showTour, setShowTour] = useState(mfaTour);
  const [currentStep, setCurrentStep] = useState(0);

  const tourSteps = [
    {
      target: '.navbar2_isec',
      content: 'Click here to view your profile and enable/disable multi factor authentication.',
      placement: 'bottom',
    },
  ];


  const inputRefs = useRef([]);



  function capitalizeFirstLetter(name) {
    if (!name) return "";
    return name.charAt(0).toUpperCase();
  }

  function capitalizeFirstNameRole(name) {
    if (!name) return "";
    return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
  }

  const updateSuccess = () => {
    toast.success("Password successfully updated...", {
      position: "top-right",
      autoClose: 2500,
      pauseOnHover: false,
    });
  };

  const handleLogout = async () => {
    try {
      await logout()
    } catch (error) {
      console.log(error.message)
    }
  }

  const specialChars = /[!@#$%^&*(),.?":{}|<>]/;

  const handleUpdatePassword = async (e) => {
    e.preventDefault();
    if (oldPassword === "") {
      setOldPasswordError("Enter your old password");
    } else if (newPassword === "") {
      setNewPasswordError("Enter your new password");
    } else if (oldPassword === newPassword) {
      setNewPasswordError("Old password and New password should not be same!");
    } else if (confirmPassword === "") {
      setConfirmPasswordError("Confirm your password ");
    } else if (newPassword !== confirmPassword) {
      setConfirmPasswordError("Password does not match !...");
      return;
    } else if (newPassword.length < 8) {
      setNewPasswordError("Password should be minimum of 8 character");
      return;
    } else if (!specialChars.test(newPassword)) {
      setNewPasswordError(
        "Password should include at least one special character"
      );
      return;
    } else if (!/[A-Z]/.test(newPassword)) {
      setNewPasswordError(
        "Password should include at least one capital alphabet"
      );
      return;
    } else {
      try {
        const response = await fetch(`${url}/updateclientpassword`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify({
            oldPassword,
            newPassword,
            confirmPassword,
          }),
        });
        if (response.status === 403) {
          toast.error("Invalid old password", {
            position: "top-right",
            autoClose: 2500,
            pauseOnHover: false,
          });
          return;
        }
        if (response.status === 400) {
          return logout();
        }
        if (response.status === 200) {
          setOldPassword("");
          setNewPassword("");
          setConfirmPassword("");
          updateSuccess();
          setTimeout(async () => {
            logout();
          }, 1000);
        }
        if (response.status === 440) {
          logout();
          toast.error("User logout due to inactivity", {
            position: "top-right",
            autoClose: 2500,
            pauseOnHover: false,
          });
          return;
        }
      } catch (error) {
        toast.error("Invalid old password", {
          position: "top-right",
          autoClose: 2500,
          pauseOnHover: false,
        });
      }
    }
  };

  const togglePasswordView = () => {
    setPasswordView(!passwordView);
  };

  const handleToggle = () => {
    setLoading(true);
    setOpenIdentity(true)
  }

  function maskEmail(email) {
    const [username, domain] = email.split('@');
    const maskedUsername =
      username.length <= 2
        ? username[0] + '*'.repeat(username.length - 1)
        : username[0] + '*'.repeat(username.length - 2) + username.slice(-1);

    return maskedUsername + '@' + domain;
  }

  const handleChange = (element, index) => {
    const value = element.value.replace(/\D/g, "");
    if (value.length > 1) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Move to next input automatically
    if (value && index < 5) {
      inputRefs.current[index + 1].focus();
    }

  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      if (otp[index] === "" && index > 0) {
        inputRefs.current[index - 1].focus();
      }
    } else if (e.key === "Enter") {
      verifyOTP(otp.join(""));
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, 6);
    if (!pasteData) return;

    const newOtp = pasteData.split("");
    for (let i = 0; i < 6; i++) {
      newOtp[i] = newOtp[i] || "";
    }

    setOtp(newOtp);
    setOtpError(false)

    // Focus last filled box
    const lastFilled = newOtp.findLastIndex((d) => d !== "");
    if (lastFilled !== -1 && inputRefs.current[lastFilled]) {
      inputRefs.current[lastFilled].focus();
    }

  };

  const startTimer = (duration = 60) => {
    setTimer(duration);
    setCanResend(false);

    const interval = setInterval(() => {
      setTimer(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          setCanResend(true);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }

  const sendOTP = async () => {
    try {
      const response = await fetch(`${url}/sendidentityotp`, {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"
        },
      })
      if (response.status === 200) {
        setOTPSent(true)
        startTimer()
        setShowResend(true)
        toast.success("OTP sent successfully", {
          position: 'top-right',
          autoClose: 2500,
          pauseOnHover: false,
        });
        return
      }
      if (response.status !== 200) {
        setOTPSent(false)
        return
      }
    } catch (error) {
      console.log(error)
      setOTPSent(false)
    }
  }

  const verifyOTP = async (e) => {
    e.preventDefault();
    if (!otp.join('')) {
      setOtpError(true);
      return;
    } else {
      try {
        const response = await fetch(`${url}/verifyidentityotp`, {
          method: "POST",
          credentials: 'include',
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            otp
          })
        })
        if (response.status === 200) {
          setOtp(['', '', '', '', '', ''])
          setOTPSent(false)
          setOpenIdentity(false)
          checkAuth()
          setLoading(false)
          toast.success("MFA updated", {
            position: 'top-right',
            autoClose: 2500,
            pauseOnHover: false,
          });
          return
        }
        if (response.status === 400) {
          toast.error("Incorrect OTP", {
            position: 'top-right',
            autoClose: 2500,
            pauseOnHover: false,
          });
          return
        }
        if (response.status === 406) {
          toast.error("OTP expired", {
            position: 'top-right',
            autoClose: 2500,
            pauseOnHover: false,
          });
          return
        }

      } catch (error) {
        console.log(error)
      }
    }
  }

  const resendIdentityOTP = async () => {
    if (!canResend) return;
    setShowResend(false);

    try {
      const response = await fetch(`${url}/resendidentityotp`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
        },
      })
      if (response.status === 200) {
        setShowResend(true);
        startTimer(60)
        toast.success("OTP sent successfully", {
          position: 'top-right',
          autoClose: 2500,
          pauseOnHover: false,
        });
      } else {
        setCanResend(true);
        setShowResend(true);
      }
    } catch (error) {
      console.log(error)
    }
  }


  return (
    <div className="isecurion_user_profile_container">
      <div className="isecurion_user_profile_inner_container">
        <div className="isecurion_user_profile_header_container">
          <h2 className="isecurion_user_profile_header">User Profile</h2>
          <button
            className="isecurion_user_profile_close_btn"
            onClick={() => setOpenUserProfile(false)}
          >
            <Icon icon="material-symbols:close" width="20" height="20" />
          </button>
        </div>

        {!openUpdatePassword ? (
          <div className="isecurion_user_profile_main_container">
            <div className="isecurion_user_profile_name_container">
              <div className="isecurion_user_first_name">
                {capitalizeFirstLetter(user)}
              </div>
            </div>

            <div className="isecurion_user_profile_detail">
              <table className="isecurion_user_profile_table">
                <tbody>
                  <tr>
                    <td>Name</td>
                    <td>:</td>
                    <td>{user}</td>
                  </tr>
                  <tr>
                    <td>Mail Id</td>
                    <td>:</td>
                    <td>{emailVer}</td>
                  </tr>
                  <tr>
                    <td>Role</td>
                    <td>:</td>
                    <td>
                      {userRole ? capitalizeFirstNameRole(userRole) : "Security Analyst"}
                    </td>
                  </tr>
                  <tr>
                    <td>Company Name</td>
                    <td>:</td>
                    <td>ISECURION</td>
                  </tr>
                  <tr>
                    <td>Multi Factor Authentication</td>
                    <td>:</td>
                    <td>
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={multifactor}
                          onChange={handleToggle}
                          disabled={loading}
                        />
                        <span className="slider round"></span>
                      </label>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="isecurion_user_profile_btns">
              <button
                onClick={() => setOpenUpdatePassword(!openUpdatePassword)}
              >
                Update Password
              </button>
              <button onClick={handleLogout}>Logout</button>
            </div>
          </div>
        ) : (
          <div className="isecurion_user_profile_update_password_container">
            <div className="isecurion_user_profile_update_password_header">
              <div
                className="isecurion_user_profile_update_password_back_btn"
                onClick={() => setOpenUpdatePassword(!openUpdatePassword)}
              >
                <Icon icon="basil:arrow-left-outline" width="24" height="24" />
              </div>
              <div className="isecurion_user_profile_update_password_heading">
                Update password
              </div>
            </div>

            <div className="isecurion_user_profile_update_password_form_container">
              <div className="isecurion_user_profile_update_password_form_field">
                <div className="isecurion_user_profile_update_password_form_field_name">
                  Current Password
                </div>
                <div className="isecurion_user_profile_update_password_form_input_field">
                  <input
                    type={passwordVisible ? "text" : "password"}
                    placeholder="Enter Your Current Password"
                    // value={oldPassword}
                    onChange={(e) => {
                      setOldPassword(e.target.value);
                      setOldPasswordError("");
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleUpdatePassword(e);
                        e.target.blur();
                      }
                    }}
                  />
                  <div
                    className="isecurion_user_profile_show_password_container"
                    onClick={() => setPasswordVisible(!passwordVisible)}
                  >
                    {passwordVisible ? (
                      <Icon
                        icon="mingcute:eye-2-line"
                        width="24"
                        height="24"
                        color="#fff"
                      />
                    ) : (
                      <Icon
                        icon="iconamoon:eye-off"
                        width="24"
                        height="24"
                        color="#777"
                      />
                    )}
                  </div>
                </div>
                {oldPasswordError && oldPassword === "" ? (
                  <p className="isecurion_user_profile_password_errors">
                    {oldPasswordError}
                  </p>
                ) : (
                  ""
                )}
              </div>

              <div className="isecurion_user_profile_update_password_form_field">
                <div className="isecurion_user_profile_update_password_form_field_name">
                  New Password
                </div>
                <div className="isecurion_user_profile_update_password_form_input_field">
                  <input
                    type={passwordView ? "text" : "password"}
                    placeholder="Enter Your New Password"
                    value={newPassword}
                    onChange={(e) => {
                      setNewPassword(e.target.value);
                      setNewPasswordError("");
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleUpdatePassword(e);
                        e.target.blur();
                      }
                    }}
                  />
                  <div
                    className="isecurion_user_profile_show_password_container"
                    onClick={() => setPasswordView(!passwordView)}
                  >
                    {passwordView ? (
                      <Icon
                        icon="mingcute:eye-2-line"
                        width="24"
                        height="24"
                        color="#fff"
                      />
                    ) : (
                      <Icon
                        icon="iconamoon:eye-off"
                        width="24"
                        height="24"
                        color="#777"
                      />
                    )}
                  </div>
                </div>
                {newPasswordError && (
                  <p className="isecurion_user_profile_password_errors">
                    {newPasswordError}
                  </p>
                )}
              </div>

              <div className="isecurion_user_profile_update_password_form_field">
                <div className="isecurion_user_profile_update_password_form_field_name">
                  Confirm Password
                </div>
                <div className="isecurion_user_profile_update_password_form_input_field">
                  <input
                    type={confirmPasswordView ? "text" : "password"}
                    placeholder="Re-Enter Your New Password"
                    // value={confirmPassword}
                    onChange={(e) => {
                      setConfirmPassword(e.target.value);
                      setConfirmPasswordError("");
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleUpdatePassword(e);
                        e.target.blur();
                      }
                    }}
                  />
                  <div
                    className="isecurion_user_profile_show_password_container"
                    onClick={() => setConfirmPasswordView(!confirmPasswordView)}
                  >
                    {confirmPasswordView ? (
                      <Icon
                        icon="mingcute:eye-2-line"
                        width="24"
                        height="24"
                        color="#fff"
                      />
                    ) : (
                      <Icon
                        icon="iconamoon:eye-off"
                        width="24"
                        height="24"
                        color="#777"
                      />
                    )}
                  </div>
                </div>
                {confirmPasswordError && (
                  <p className="isecurion_user_profile_password_errors">
                    {confirmPasswordError}{" "}
                  </p>
                )}
              </div>

              <div className='wrap_update_isec_button'>
                <button style={{ marginTop: "30px" }} onClick={handleUpdatePassword}>Save</button>
              </div>
            </div>
          </div>
        )}

        {openIdentity && (
          <div className="isecurion_user_dropdown">
            <div className='isecurion_identity_dropdown'>
              <div className='wrap_identity_heading'>
                <h1>Multi Factor Authentication</h1>
                <button onClick={() => {
                  setOpenIdentity(false)
                  setLoading(false);
                  setOTPSent(false)
                }}><FontAwesomeIcon icon={faXmark} /></button>
              </div>
              <div className='wrap_identify_content'>
                <div>
                  <h2>Verify your identity</h2>
                  {otpSent ? (
                    <div>
                      <p>Enter the OTP sent to <strong>{maskEmail(emailVer)}</strong></p>
                      <div className="otp-container">

                        {otp?.map((digit, index) => (
                          <input
                            key={index}
                            ref={(el) => (inputRefs.current[index] = el)}
                            type="text"
                            className={`otp-box ${otpError ? "otp-error" : ""}`}
                            maxLength={1}
                            value={digit}
                            onChange={(e) => {
                              handleChange(e.target, index)
                              if (otpError) setOtpError(false);
                            }}
                            onKeyDown={(e) => handleKeyDown(e, index)}
                            onPaste={handlePaste}
                          />
                        ))}
                      </div>
                      {showResend && (
                        <p
                          style={{
                            marginTop: "10px",
                            color: canResend ? "#0077b6" : "#999",
                            cursor: canResend ? "pointer" : "not-allowed",
                          }}
                          onClick={resendIdentityOTP}>
                          {canResend ? "Resend OTP" : `Resend OTP in ${timer}s`}
                        </p>
                      )}
                    </div>
                  ) : (
                    <div>
                      <p>For Security reasons, we need to verify your identity before proceeding.</p>
                      <p>A one-time password will be sent to your registered email address <strong>{maskEmail(emailVer)}</strong></p>
                    </div>
                  )}

                  <div className='wrap_send_otp_button'>
                    {otpSent ? (
                      <button onClick={verifyOTP}>Verify</button>
                    ) : (
                      <button onClick={sendOTP}>Send OTP</button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {showTour && (
          <GuidedTour
            steps={tourSteps}
            firstletter={firstLetter}
            currentStep={currentStep}
            checkAuth={checkAuth}
            toggleDropdown={toggleDropdown}
            setCurrentStep={setCurrentStep}
            onFinish={() => setShowTour(false)}
          />
        )}
      </div>
    </div>
  );
};

export default UserProfile;